import React from 'react';
export function AboutSection() {
  return <section id="about" className="py-24 bg-navy-900 relative border-t border-navy-700" data-id="element-11">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-12">
        <h2 className="text-sm font-bold tracking-widest text-gold uppercase mb-6" data-id="element-13">
          Executive Profile
        </h2>

        <div className="relative" data-id="element-14">
          <span className="absolute -top-10 -left-6 text-8xl text-navy-700/50 font-serif leading-none" data-id="element-15">
            "
          </span>
          <p className="text-2xl sm:text-3xl lg:text-4xl text-white/90 leading-snug font-light relative z-10" data-id="element-16">
            I am a revenue growth architect and CRO-level leader who transforms
            complex market challenges into scalable enterprise engines. By
            aligning go-to-market strategy with rigorous sales execution, I
            build organizations that consistently capture market share and forge
            high-value partnerships with the world's leading brands.
          </p>
          <span className="absolute -bottom-16 -right-6 text-8xl text-navy-700/50 font-serif leading-none" data-id="element-17">
            "
          </span>
        </div>

        <div className="mt-16 w-24 h-1 bg-gradient-to-r from-gold to-transparent mx-auto rounded-full" data-id="element-18"></div>

        <p className="mt-8 text-white/50 text-lg leading-relaxed max-w-3xl mx-auto" data-id="element-19">
          With a career spanning SaaS, advanced materials, sports, and consumer
          sectors, I bring a unique ability to build national sales teams,
          design go-to-market strategies, and structure enterprise partnerships
          with Fortune 500 companies.
        </p>
      </div>
    </section>;
}